import React from 'react';
import './../index.css';
import DocumentIcon from '../../../components/Icons/DocumentIcon';
import CheckIcon from '../../../components/Icons/CheckIcon';
import AlertIcon from '../../../components/Icons/AlertIcon';

export const Stats = ({
  total = 0,
  completed = 0,
  active = 0,
  style = {},
}) =>
{
  return (
    <>
      <div
        className="stats-container grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8 lg:gap-10 px-4 md:px-6 lg:px-8">
        <div className="stats">
          <div className="stat">
            <div className="stat-row">
              <span>Total</span>
              <span>{total}</span>
            </div>
            <div className="stat-icon document">
              <DocumentIcon/>
            </div>
          </div>

          <div className="stat">
            <div className="stat-row">
              <span>Completed</span>
              <span>{completed}</span>
            </div>
            <div className="stat-icon check">
              <CheckIcon/>
            </div>
          </div>

          <div className="stat">
            <div className="stat-row">
              <span>Active</span>
              <span>{active}</span>
            </div>
            <div className="stat-icon issue">
              <AlertIcon/>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};